module.exports = __webpack_public_path__ + "img/monitor.06e84f92.svg";